'use strict'

export default {
  parseJSON (string) {
    var _res = null
    try {
      _res = JSON.parse(string)
    } catch (e) {}
    return _res
  },
  filterProps (self, keys) {
    var _props = Object.assign({}, self.$props)
    // Removemos os atributos que fazem sentido para o componente atual e
    // retornamos o resto para depois passar para o componente novo
    for (var idx in keys) {
      delete _props[keys[idx]]
    }
    return _props
  },
  validateStrongPassword (val) {
    // Pelo menos uma letra minúscula
    // Pelo menos uma letra maiúscula
    // Pelo menos um caractere especial \$^*+=?.()|{}!@%&:;<>~_
    const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$+#!%*?&])[A-Za-z\d@$+#!%*?&]/
    return reg.test(val)
  },
  // password must not contain 3 consecutive characters (e.g. 'aaa','123','abc','cba')
  validateConsecutiveCharacters (value) {
    const regex = /(.)\1{2}/
    return !regex.test(value)
  },
  // password must not contain the word "password", "senha" or "mudar"
  validatePasswordContainsReservedWords (value) {
    const formattedValue = value.toLowerCase()
    return !(formattedValue.includes('password') || formattedValue.includes('senha') || formattedValue.includes('mudar'))
  },
  getStyle (element, property) {
    var _res = null
    if (
      window.getComputedStyle &&
      (element instanceof Element || element instanceof HTMLDocument)
    ) {
      _res = window.getComputedStyle(element, null).getPropertyValue(property)
    } else {
      _res =
        element.style[
          property.replace(/-([a-z])/g, function (g) {
            return g[1].toUpperCase()
          })
        ]
    }
    return _res
  }
}
